export const fire_resize = () => {
    if (document.createEvent) {
        const e = document.createEvent("Event");
        e.initEvent("resize", true, true);
        window.dispatchEvent(e)
    } else {
        const element = document.documentElement;
        const a = document.createEventObject();
        element.fireEvent("onresize", a)
    }
}